<mat-chip  [class]="chipClass()">
	<div class="status-chip__content">
			<div class="status-chip__circle"></div>
			@if(translatedValue(); as translatedValue){
				<span class="mat-label-medium">{{translatedValue.defaultText | translate : translatedValue.token :translatedValue.scope}}</span>
			}
			@else if (value()) {
					<span class="mat-label-medium">{{value()}}</span>
			}			
	</div>
<ng-content/>
</mat-chip>